import React from 'react';
import { groupBy } from '../../../helpers/HelperMethods';

//const CancelToken = axios.CancelToken;

const ConnectorsList = ({app}) => {

    //const [connectors, setConnectors] = useState([]);
    //const cancelSource = useRef(null);

    // useEffect(() => {
    //     return getConnectors(app.appId);
    // }, []);

    // const getConnectors = (appId) =>  {
    //     if (cancelSource.current) {
    //     cancelSource.current.cancel();
    //     }

    //     cancelSource.current = CancelToken.source();

    //     Api.get(`/PowerAppConnector?appId=${appId}`)
    //         .then(res => res.data)
    //         .then(con => {
    //             setConnectors(con);
    //         });


    //     return () => {
    //         cancelSource.current.cancel();
    //     }
    // }

    const renderConnectors = (connectors) => {
        const groupedByTier = groupBy(connectors, 'tier');
        return Object.keys(groupedByTier).map((x, index) =>
            <div key={index} style={{display: 'flex', marginBottom: 2}}>
                <div className='textField' style={{minWidth: 80}}>{x}: {renderConnectorsNames(groupedByTier[x])}</div>
                {/* <TextField readOnly={true} styles={{root: {flex: '1'}}} value={renderConnectorsNames(groupedByTier[x])} /> */}
            </div>
        )
    }

    const renderConnectorsNames = (connectors) => {
        return connectors.map(x => x.name).join(', ');
    }

    return(
        <div>{renderConnectors(app.connectors)}</div>
    )

}

export default ConnectorsList;


// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/ConnectorsList.js